function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @packageDocumentation
 * @internalapi
 */
// @ts-nocheck
// NOTE (csantos): This file was taken directly from twilio-video and has been renamed from JS to TS only.
// It needs to be re-written as part of the overall updating of the files to TS.
import { EventEmitter } from 'events';

var Backoff = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Backoff, _EventEmitter);

  var _super = _createSuper(Backoff);

  /**
   * Construct a {@link Backoff}.
   * @param {object} options
   * @property {number} min - Initial timeout in milliseconds [100]
   * @property {number} max - Max timeout [10000]
   * @property {boolean} jitter - Apply jitter [0]
   * @property {number} factor - Multiplication factor for Backoff operation [2]
   */
  function Backoff(options) {
    var _this;

    _classCallCheck(this, Backoff);

    _this = _super.call(this);
    Object.defineProperties(_assertThisInitialized(_this), {
      _attempts: {
        value: 0,
        writable: true
      },
      _duration: {
        enumerable: false,
        get: function get() {
          var ms = this._min * Math.pow(this._factor, this._attempts);

          if (this._jitter) {
            var rand = Math.random();
            var deviation = Math.floor(rand * this._jitter * ms); // tslint:disable-next-line

            ms = (Math.floor(rand * 10) & 1) === 0 ? ms - deviation : ms + deviation;
          } // tslint:disable-next-line


          return Math.min(ms, this._max) | 0;
        }
      },
      _factor: {
        value: options.factor || 2
      },
      _jitter: {
        value: options.jitter > 0 && options.jitter <= 1 ? options.jitter : 0
      },
      _max: {
        value: options.max || 10000
      },
      _min: {
        value: options.min || 100
      },
      _timeoutID: {
        value: null,
        writable: true
      }
    });
    return _this;
  }

  _createClass(Backoff, [{
    key: "backoff",
    value: function backoff() {
      var _this2 = this;

      var duration = this._duration;

      if (this._timeoutID) {
        clearTimeout(this._timeoutID);
        this._timeoutID = null;
      }

      this.emit('backoff', this._attempts, duration);
      this._timeoutID = setTimeout(function () {
        _this2.emit('ready', _this2._attempts, duration);

        _this2._attempts++;
      }, duration);
    }
  }, {
    key: "reset",
    value: function reset() {
      this._attempts = 0;

      if (this._timeoutID) {
        clearTimeout(this._timeoutID);
        this._timeoutID = null;
      }
    }
  }]);

  return Backoff;
}(EventEmitter);

export default Backoff;